import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecipeWorklistComponent } from './recipe-worklist/recipe-worklist.component';
import { CreateRecipeComponent } from './create-recipe/create-recipe.component';
import { ViewRecipeComponent } from './view-recipe/view-recipe.component';
import { NonPlmRecipeComponent } from './non-plm-recipe.component';
import { CanDeactivateGuard } from 'src/app/guards/can-deactivate.guard';

const routes: Routes = [
  {
      path: '',
      component: NonPlmRecipeComponent ,
      children: [
          {
            path: 'manage-recipe',
            component: RecipeWorklistComponent
          },
          {
              path: 'create-recipe',
              component: CreateRecipeComponent,
              canDeactivate: [CanDeactivateGuard]
          },
          {
              path: 'view-recipe',
              component: ViewRecipeComponent
          }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NonPlmRecipeRoutingModule { }
